import { takeLatest, call, put } from 'redux-saga/effects';
import _ from 'lodash';
import {
  FETCH_ITEM_TYPES,
  fetchItemTypesSuccess,
  fetchItemTypesFailed,
  fetchingItemTypes,
} from '../actions/itemtypes';

import { fetchCol } from './helper';

function fetchItemTypes() {
  return fetchCol('itemtypes')
    .then((itemTypes) => _.pickBy(itemTypes, (value) => !value.deleted))
}

function* fetchItemTypesSaga() {
  try {
    yield put(fetchingItemTypes());
    const itemTypes = yield call(fetchItemTypes);
    yield put(fetchItemTypesSuccess(itemTypes));
  } catch (err) {
    console.error('error', err);
    yield put(fetchItemTypesFailed(err));
  }
}

function* watchFetchItemTypesSaga() {
  yield takeLatest(FETCH_ITEM_TYPES, fetchItemTypesSaga);
}

// function fetchItem(id) {
//   const path = `static/items/${id}`;
//   return fetch(path);
// }
//
// function* fetchItemSaga(action) {
//   try {
//     yield put(fetchingItem());
//     const taskProfile = yield call(fetchItem, action.taskProfileId);
//     yield put(fetchItemSuccess(taskProfile));
//   } catch (e) {
//     console.error('Failed to load task profile', e);
//     yield put(fetchItemFailed(e));
//   }
// }
//
// function* watchFetchItemSaga() {
//   yield takeLatest(FETCH_ITEM, fetchItemSaga);
// }

export {
  fetchItemTypesSaga,
  watchFetchItemTypesSaga,
  // fetchItemSaga,
  // watchFetchItemSaga,
};



// WEBPACK FOOTER //
// ./src/sagas/itemtypes.js